import React, { useEffect, useState } from "react"
import { Link, useHistory, withRouter } from "react-router-dom"
import {
  Col,
  Container,
  Row,
  Table,
  Label,
  UncontrolledTooltip,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
} from "reactstrap"

//Import Component
import Breadcrumbs from "components/Common/Breadcrumb"

import axios from "axios"
import PaginationComponent from "common/PaginationComponent"
import { convertPermission } from "permissionUtils"
import UnAuthorizedComponent from "common/UnAuthorizedComponent"
import UploadFiles from "./UploadFiles"
import NewSessionResults from "./NewSessionResults"
import ProgressBar from "./ProgressBar"

const BaladiHistory = () => {
  const history = useHistory()
  const [layout, setLayout] = useState("upload")
  const [loading, setLoading] = useState(false)
  const [batchID, setBatchID] = useState()
  const [statusResults, setStatusResults] = useState([])
  const [batchDetails, setBatchDetails] = useState()

  // console.log("statusResults", statusResults)

  // **************** Permissions ******************************
  const userPermissions = convertPermission(
    JSON.parse(localStorage.getItem("roles"))
  )
  // console.log("userPermissions", userPermissions)

  // **************** Authorization ******************************
  const [auth, setAuth] = useState(false)

  useEffect(() => {
    const formData = {
      PerToken: localStorage.getItem("token"),
      PerUserID: localStorage.getItem("id"),
      PerRoleID: localStorage.getItem("userRoleID"),
    }

    // axios
    //   .post(process.env.REACT_APP_API_URL + `api/MissingDataView`, formData)
    //   .then(res => {
    //     if (res.data.error === true && res.data.message === "Access denied!") {
    //       setAuth(true)
    //       setTimeout(() => {
    //         history.push("/logout")
    //         setTimeout(() => {
    //           history.push("/login")
    //         }, 1000)
    //       }, 4000)
    //     }

    //     // console.log(res.data)
    //     setTotalPages(res.data.TotalPages)
    //     let resData = Object.values(res.data)

    //     // Removing page number info from the array
    //     resData.splice(-4)
    //     setMissingData(resData)
    //     setTimeout(() => {
    //       setLoading(false)
    //     }, 2000)
    //   })
    //   .catch(err => {
    //     console.log(err)
    //   })
  }, [])

  // Access denied !!
  if (auth) {
    return <UnAuthorizedComponent />
  }

  // not allowed views
  if (
    userPermissions.R3.P !== "1" &&
    userPermissions.R3.P !== "2" &&
    userPermissions.R3.P !== "3" &&
    userPermissions.R3.P !== "4" &&
    userPermissions.R3.G !== "1"
  )
    return (
      <div className="page-content">
        <h3 className="d-flex justify-content-center p-3 text-light bg-danger">
          You are not authenticated!!
        </h3>
      </div>
    )
  else {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumbs */}
            <Breadcrumbs title="Baladi" breadcrumbItem="Baladi Status" />

            {layout === "upload" && (
              <UploadFiles
                loading={loading}
                setLoading={setLoading}
                setBatchID={setBatchID}
                setLayout={setLayout}
              />
            )}

            {layout === "loading" && (
              <ProgressBar
                batchID={batchID}
                setLayout={setLayout}
                setStatusResults={setStatusResults}
                setBatchDetails={setBatchDetails}
              />
            )}

            {layout === "results" && (
              <NewSessionResults
                type="upload"
                statusResults={statusResults}
                batchDetails={batchDetails}
                setLayout={setLayout}
              />
            )}
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

export default BaladiHistory
